import React from 'react';
import { Navbar, Image, OverlayTrigger, Popover } from 'react-bootstrap';
import { List } from 'react-bootstrap-icons';
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import logoutarrow from '../../assets/images/logout.svg';

const Header = ({ sidebar, setSidebar }) => {
  const { instance } = useMsal();

  const [randomColor, setRandomColor] = React.useState('#F9F2F6');
  const [randomFontColor, setRandomFontColor] = React.useState('#810055');

  React.useEffect(() => {
    // Brand-compliant colours only
    setRandomColor('#F9F2F6');
    setRandomFontColor('#810055');
  }, []);

  const handleLogout = () => {
    sessionStorage.clear();
    localStorage.clear();
    
    // Redirect to root path
    const baseUrl = window.location.origin;
    const logoutUrl = `${baseUrl}/`;
    
    // Force logout with prompt parameter to ensure fresh login
    const logoutRequest = {
      account: instance.getActiveAccount(),
      postLogoutRedirectUri: logoutUrl,
      mainWindowRedirectUri: logoutUrl
    };
    
    instance.logoutRedirect(logoutRequest).catch(() => {});
  };

  const logoStyle = {
    background: '#F9F2F6',
    color: '#810055'
  };

  const userlogo = (name) => {
    if (!name) return 'U';
    const parts = name.split(' ');
    if (parts.length >= 2) {
      return parts[0][0].toUpperCase() + parts[1][0].toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  return (
    <Navbar bsPrefix="header">
      <div className="sidebar-head-header">
        <List 
          className="head-toggle" 
          onClick={() => setSidebar(sidebar === 'closed' ? 'open' : 'closed')}
        />
      </div>
      <div className="app-name">IOD</div>
      <div className="user-section">
        <OverlayTrigger 
          trigger="click" 
          placement="bottom-end" 
          rootClose 
          overlay={
            <Popover className="profile">
              <div className="user-section">
                <div className="user-logo" style={logoStyle}>
                  {userlogo(sessionStorage.getItem('UserName'))}
                </div>
                <div className="user-info">
                  <span className="user-name">{sessionStorage.getItem('UserName')}</span>
                  <span className="user-email">{sessionStorage.getItem('Email')}</span>
                </div>
                <Image src={logoutarrow} onClick={handleLogout} style={{ cursor: 'pointer', width: '20px' }} />
              </div>
            </Popover>
          }
        >
          <div className="user-logo" style={logoStyle}>
            {userlogo(sessionStorage.getItem('UserName'))}
          </div>
        </OverlayTrigger>
      </div>
    </Navbar>
  );
};

export default Header;
